import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderKempPartners extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
        this.partnerTypesTaxonId = '94bb48a6-d944-4834-9cf4-1196dbf61e77';
        this.partnerSpecializationsTaxonId = '0dda20a2-f2af-4434-947f-86773ead8524'
    }

    getItemHtml(item, relatedMedia) {
        const img = (item.Logo) ? item.Logo.Url : '';
        const partnerTypeData = item.partnerType.filter(type => type.ParentId === this.partnerTypesTaxonId);
        let partnerTypeStr = "";
        if(partnerTypeData.length > 0) {
            partnerTypeStr = 
            `<dt>Partner Type</dt>
            <dd>${partnerTypeData.map(u => u.Title).join(', ')}</dd>`;
        }
        const countryData = item.countryData.map(country => country.Title).join(', ');
        const languageInput = (window.ResourceCenterSettings && window.ResourceCenterSettings.LanguageSelector) ? document.querySelector(`.${window.ResourceCenterSettings.LanguageSelector}`) : null;
        const itemUrl = languageInput ? `/${languageInput.id}/kemp-partner/${item.UrlName}` : `/kemp-partner/${item.UrlName}`;
        const html = `
        <div class="Card Elevated">
            <div class="-p3">
                <div class="row">
                    <div class="col-3 -xl-fourth">
                        <img src="${img}" class="-wa" loading="lazy" />
                    </div>
                    <div class="col-9">
                        <h4>
                            <a href="${itemUrl}">${this.encodeHtml(item.Title)}</a>
                        </h4>
                        <dl class="-vs1">

                            ${item.Email && `
                            <dt>Email</dt>
                            <dd><a href="mailto:${item.Email}">${item.Email}</a></dd>
                            `}

                            ${item.Phone && `
                            <dt>Phone</dt>
                            <dd>${item.Phone}</dd>
                            `}

                            ${item.PostalCode && `
                            <dt>Postal Code</dt>
                            <dd>${item.PostalCode}</dd>
                            `}

                            ${item.Locality && `
                            <dt>Locality</dt>
                            <dd>${item.Locality}</dd>
                            `}

                            ${item.Premise && `
                            <dt>Premise</dt>
                            <dd>${item.Premise}</dd>
                            `}

                            ${item.State && `
                            <dt>State</dt>
                            <dd>${item.State}</dd>
                            `}

                            ${item.Thoroughfare && `
                            <dt>Thoroughfare</dt>
                            <dd>${item.Thoroughfare}</dd>
                            `}

                            ${item.Website && `
                            <dt>Website</dt>
                            <dd class="-hyphenate"><a href="${item.Website}" target="_blank">${item.Website}</a></dd>
                            `}

                            ${partnerTypeStr}

                            ${countryData && `
                            <dt>Country</dt>
                            <dd>${countryData}</dd>
                            `}
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    `;
        return html;

    }
}
